import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import UserManagement from '../../../components/siteadmin/UserManagement';
import Loader from '../../../components/Loader/Loader';
import usersQuery from '../../../components/siteadmin/UserManagement/usersQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './Users.css';

class Users extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
      userType: ''
    };
    this.setStateVariable = this.setStateVariable.bind(this);
  }

  setStateVariable(variables) {
    this.setState(variables)
  }

  render() {
    const { currentPage, searchList, userType } = this.state;
    const { userManagement: { loading } } = this.props

    return <UserManagement
      currentPage={currentPage}
      searchList={searchList}
      userType={userType}
      setStateVariable={this.setStateVariable}
      isLoading={loading}
    />;
  }
}

export default compose(
  withStyles(s),
  withQuery(usersQuery, {
    name: 'userManagement',
    options: {
      variables: {
        currentPage: 1,
        searchList: "",
        userType: ""
      },
      fetchPolicy: 'network-only',
      ssr: false
    }
  }),
)(Users);